import { render, staticRenderFns } from "./YjjAdmin.vue?vue&type=template&id=f7998598&scoped=true&"
import script from "./YjjAdmin.vue?vue&type=script&lang=js&"
export * from "./YjjAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7998598",
  null
  
)

export default component.exports